<app-fixed-content-page
  [content]="content"
  [action]="action"
/>

<ng-template #content>
  <h1 class="text-bold m-b-5 m-t-5">Welcome to the Aptem Assess cognitive assessment</h1>

  <div class="content-layout-column">
    <app-content
      [key]="initiationIntroKey"
      [value]="initiationIntroValue$ | async"
      [trackingId]="initiationIntroKey"
    >
      <div defaultContent>
        <p>
          You have been invited to complete a short assessment aimed at identifying how we can support your learning
          journey. This is not a test, you cannot pass or fail, and this does not in any way impact your place on the
          programme.
        </p>

        <p class="mb-0">
          This assessment will take approximately 15-30 minutes to complete and comprises eight engaging games. Please
          answer as many questions as possible within each game. It is best to complete this activity in a quiet place
          where you will not be distracted.
        </p>
      </div>
    </app-content>

    <div>
      <!-- NOTE: To be refactored -->
      <div class="details-container rounded-8 overflow-hidden">
        <div class="tip-header d-flex align-items-center p-2">
          <div class="bg-white rounded-circle p-2 m-2">
            <svg-icon
              src="assets/icons/help.svg"
              [svgStyle]="{ 'width.px': 24 }"
            >
            </svg-icon>
          </div>
          <span class="text-white font-size-18 fw-bolder m-2">The purpose of the cognitive assessment</span>
        </div>
        <div class="d-md-flex align-items-center">
          <div class="m-3 m-md-0 text-center text-md-start">
            <div class="p-3 p-lg-4">
              <ul class="assessment-desc pt-1 ps-3">
                <li class="pb-3">
                  Cognitive assessments measure your thinking abilities, including; reasoning, perception, memory,
                  problem-solving skills and verbal reasoning.
                </li>
                <li>
                  Assessing these areas indicates whether you may require additional support with your learning, to
                  maximise your chance of success.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #action>
  <div class="action-button-block-sm-end-md">
    <app-button
      trackingId="assessment-welcome"
      (clicked)="openAssessment()"
    >
      Start assessment
    </app-button>
  </div>
</ng-template>
